// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Uw-z","modalContent":"Vw-z","header":"Ww-z","close":"Xw-z"};